import styled from 'styled-components'

export const CityPlanCreateWrapper = styled.div``
